
export const validateDni = (cedula: string) => {

    if (cedula.length == 10) {
        const wced = cedula.substring(0, 9);
        const verif = cedula.substring(9, 10);

        let wd: number = 0;
        let wc: number = 0;
        let wa: number = 0;
        let wb: number = 0;

        for (let i = 0; i <= wced.length - 1; i = i + 2) {
            wa = +wced.substring(i, i + 1);
            wb = wa * 2;
            wc = wb;
            if (wb > 9) {
                wc = wb - 9;
            }
            wd = wd + wc;
        }

        wa = 0;
        for (let i = 1; i <= wced.length - 1; i = i + 2) {
            wa = +wced.substring(i, i + 1);
            wd = wd + wa;
        }
        let wn: number;
        wn = wd / 10;
        let wn2: number = Math.ceil(wn);
        wn2 = wn2 * 10;
        let digit: number = wn2 - wd;

        let verifNumber = new Number(verif);
        if (digit == verifNumber) {
            return true; //Valido
        } else {
            return false;
        }
    } else if ( cedula.length > 10 && cedula.length <= 13 ){
        return true; //no se valida RUC
    }

    return false;
}


export const isEmptyOrNull = (query: string) => {
    return query == null || query.length == 0;
}

export const validateRUC = (ruc: string) => {
    return ruc && ruc.length == 13;
}

export const validateDNIPattern = (value: string) => {
    const regexp = new RegExp('^[0-9]{2,13}$');
    return regexp.test(value.trim());
}

export function getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
}

export function precisionRound(number: number, precision: number) {
    if (precision < 0) {
        let factor = Math.pow(10, precision);
        return Math.round(number * factor) / factor;
    }
    else
        return +(Math.round(Number(number + "e+" + precision)) +
            "e-" + precision);
}



export function validateEmail(input: string) {
    var validRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (input.match(validRegex)) {
        return true;
    } else {
        return false;
    }
}
//2023-11-04T01:07:40.652+00:00
const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?$/;
const pgDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)(?:\+\d{2}:\d{2})?$/;
const fazilDateFormat = /^\d{4}-\d{2}-\d{2}(?:\.\d*)?$/;

function isIsoDateString(value: any): boolean {
  return value && typeof value === "string" && isoDateFormat.test(value);
}
function isPGDateString(value: any): boolean {
  return value && typeof value === "string" && pgDateFormat.test(value);
}

function isFazilDateString(value: any): boolean {
  return value && typeof value === "string" && fazilDateFormat.test(value);
}

export function handleDates(body: any) {
    
  if (body === null || body === undefined || typeof body !== "object")
    return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (isIsoDateString(value)) body[key] = parseISO(value);
    else if (isPGDateString(value)) body[key] = parseISO(value) 
    else if (isFazilDateString(value)) body[key] = parseFazil(value) 
    else if (typeof value === "object") handleDates(value);
  }
}

export function parseISO(value: any): any {
    return new Date(value);
}

export function parseFazil(value: any): any {
    value = value.replace(/-/g, '\/').replace(/T.+/, '');
    return new Date(value);
}
export function toLowerCase(value: string): string {
    return value.trim().toLocaleLowerCase();
}